import { Component, Input } from '@angular/core';

/**
 * Read-only 1-5 star display. `value` may be fractional (e.g. an average); it is rounded to
 * the nearest whole star for display.
 */
@Component({
  selector: 'app-star-rating',
  template: `<span class="star-rating">
    <i *ngFor="let filled of stars" class="bx" [class.bxs-star]="filled" [class.bx-star]="!filled"></i>
  </span>`,
  styles: [
    `.star-rating i {
      color: #f1b44c;
      font-size: 1rem;
    }`,
  ],
})
export class StarRatingComponent {
  @Input() value = 0;
  @Input() max = 5;

  get stars(): boolean[] {
    const rounded = Math.round(Number(this.value) || 0);
    return Array.from({ length: this.max }, (_, i) => i < rounded);
  }
}
